// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import router from './router'
import VueSweetalert2 from 'vue-sweetalert2'
import 'vue-datetime/dist/vue-datetime.css'
import moment from 'moment-timezone'
import Buefy from 'buefy'
import 'buefy/dist/buefy.css'
import axios from 'axios'
import VueAxios from 'vue-axios'
import { CoolSelectPlugin } from 'vue-cool-select'


// paste the line below only if you need "bootstrap" theme
import 'vue-cool-select/dist/themes/bootstrap.css'

Vue.use(CoolSelectPlugin)

Vue.use(VueAxios, axios)


Vue.use(BootstrapVue)
Vue.use(VueSweetalert2)
Vue.use(Buefy)
Vue.use(moment)


Vue.filter('formatDate', function(value) {
  if (value) {
    return moment.tz(String(value),'America/Cancun').format('DD/MM/YYYY')
  }
})

Vue.filter('formatDate2', function(value) {
  if (value) {
    return moment.tz(String(value),'America/Cancun').format('DD/MM/YYYY')
  }
})

Vue.filter('toMXN',function(value){
  if (value) {
      return `$${value.toLocaleString()}`
  }
})

export const url = 'https://rubby2.hotel-arrecife.com/wsimportaciones/'
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: {
    App
  }
})



// WEBPACK FOOTER //
// ./src/main.js